import React from "react";
import { useTranslation } from "react-i18next";
import { getStatusConfig } from "./statusConfig";
import StatusIcon from "./StatusIcon";

const PaymentFeedback = ({
  type,
  action,
  className,
  group,
  isRS = false,
  currency,
}) => {
  const { t } = useTranslation();
  const { title, message, icon } = getStatusConfig(type, group, t, currency);

  const handleAction = () => {
    if (type === 100) {
      window.location.reload();
    } else {
      action?.();
    }
  };

  return (
    <div
      className={`flex flex-col z-50 items-center w-[250px] justify-center text-center pt-[0.8rem] pb-[0.3rem] ${
        className ? "bg-white rounded-[16px] h-[200px] p-[40px] mt-[200px]" : ""
      }`}
    >
      <StatusIcon type={icon} />
      <h2 className="mt-[0.875rem] text-[1.0625rem] leading-[1.375rem] text-black font-bold">
        {title}
      </h2>
      <p className="text-[0.8125rem] mt-1">{message}</p>
      <button
        className="text-black-500 uppercase font-bold mt-2"
        onClick={handleAction}
      >
        {isRS ? "Go back" : "Ok"}
      </button>
    </div>
  );
};

export default PaymentFeedback;
